var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from "react";
import Checkbox from "../atoms/Checkbox";
export var MultiSelect = function (_a) {
    var options = _a.options, selectedValues = _a.selectedValues, onChange = _a.onChange, _b = _a.placeholder, placeholder = _b === void 0 ? "Select options..." : _b, _c = _a.searchPlaceholder, searchPlaceholder = _c === void 0 ? "Search options..." : _c, _d = _a.className, className = _d === void 0 ? "" : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e;
    var _f = useState(false), isOpen = _f[0], setIsOpen = _f[1];
    var _g = useState(""), searchTerm = _g[0], setSearchTerm = _g[1];
    var dropdownRef = useRef(null);
    // Close dropdown when clicking outside
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () { return document.removeEventListener("mousedown", handleClickOutside); };
    }, []);
    // Filter options based on search term
    var filteredOptions = options.filter(function (option) { return option.label.toLowerCase().includes(searchTerm.toLowerCase()); });
    // Handle individual option toggle
    var handleOptionToggle = function (value) {
        var newSelectedValues = selectedValues.includes(value)
            ? selectedValues.filter(function (v) { return v !== value; })
            : __spreadArray(__spreadArray([], selectedValues, true), [value], false);
        onChange(newSelectedValues);
    };
    // Handle Select All
    var handleSelectAll = function () {
        var allFilteredValues = filteredOptions.map(function (option) { return option.value; });
        var combinedValues = __spreadArray(__spreadArray([], selectedValues, true), allFilteredValues, true);
        var newSelectedValues = Array.from(new Set(combinedValues));
        onChange(newSelectedValues);
    };
    // Handle Clear All
    var handleClearAll = function () {
        if (searchTerm === "") {
            // If no search term, clear all selected values
            onChange([]);
        }
        else {
            // If there's a search term, only clear the filtered options
            var filteredValues_1 = filteredOptions.map(function (option) { return option.value; });
            var newSelectedValues = selectedValues.filter(function (value) { return !filteredValues_1.includes(value); });
            onChange(newSelectedValues);
        }
    };
    // Get display text
    var getDisplayText = function () {
        if (selectedValues.length === 0)
            return placeholder;
        if (selectedValues.length === 1) {
            var option = options.find(function (opt) { return opt.value === selectedValues[0]; });
            return (option === null || option === void 0 ? void 0 : option.label) || selectedValues[0];
        }
        return "".concat(selectedValues.length, " selected");
    };
    return (React.createElement("div", { className: "lib-multiselect ".concat(className), ref: dropdownRef },
        React.createElement("button", { type: "button", className: "lib-multiselect__trigger", onClick: function () { return !disabled && setIsOpen(!isOpen); }, disabled: disabled, style: {
                width: "100%",
                padding: "8px 12px",
                border: "1px solid var(--lib-border, #dee2e6)",
                borderRadius: "4px",
                backgroundColor: disabled ? "#f8f9fa" : "white",
                color: disabled ? "#6c757d" : "inherit",
                textAlign: "left",
                cursor: disabled ? "not-allowed" : "pointer",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                fontSize: "14px",
            } },
            React.createElement("span", null, getDisplayText()),
            React.createElement("span", { style: { transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" } }, "\u25BC")),
        isOpen && (React.createElement("div", { className: "lib-multiselect__dropdown", style: {
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                zIndex: 1000,
                backgroundColor: "white",
                border: "1px solid var(--lib-border, #dee2e6)",
                borderRadius: "4px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                maxHeight: "300px",
                overflow: "hidden",
                marginTop: "2px",
            } },
            React.createElement("div", { style: { padding: "8px" } },
                React.createElement("input", { type: "text", placeholder: searchPlaceholder, value: searchTerm, onChange: function (e) { return setSearchTerm(e.target.value); }, style: {
                        width: "100%",
                        padding: "6px 8px",
                        border: "1px solid var(--lib-border, #dee2e6)",
                        borderRadius: "4px",
                        fontSize: "14px",
                        outline: "none",
                    } })),
            React.createElement("div", { style: {
                    padding: "8px",
                    borderBottom: "1px solid var(--lib-border, #dee2e6)",
                    display: "flex",
                    gap: "12px",
                } },
                React.createElement("button", { type: "button", onClick: handleSelectAll, style: {
                        background: "none",
                        border: "none",
                        color: "var(--lib-primary, #007bff)",
                        cursor: "pointer",
                        fontSize: "12px",
                        fontWeight: "500",
                    } }, "Select All"),
                React.createElement("span", { style: { color: "#dee2e6" } }, "|"),
                React.createElement("button", { type: "button", onClick: handleClearAll, style: {
                        background: "none",
                        border: "none",
                        color: "var(--lib-primary, #007bff)",
                        cursor: "pointer",
                        fontSize: "12px",
                        fontWeight: "500",
                    } }, "Clear All")),
            React.createElement("div", { style: { maxHeight: "200px", overflowY: "auto" } }, filteredOptions.length === 0 ? (React.createElement("div", { style: {
                    padding: "12px",
                    textAlign: "center",
                    color: "#6c757d",
                    fontSize: "14px",
                } }, "No options found")) : (filteredOptions.map(function (option) { return (React.createElement("div", { key: option.value, style: {
                    padding: "8px 12px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: "14px",
                    borderBottom: "1px solid #f8f9fa",
                }, onClick: function () { return handleOptionToggle(option.value); }, onMouseEnter: function (e) {
                    e.currentTarget.style.backgroundColor = "#f8f9fa";
                }, onMouseLeave: function (e) {
                    e.currentTarget.style.backgroundColor = "transparent";
                } },
                React.createElement(Checkbox, { checked: selectedValues.includes(option.value), onChange: function () { return handleOptionToggle(option.value); }, label: "" }),
                React.createElement("span", null, option.label))); })))))));
};
